module.exports = __webpack_public_path__ + "img/bg_img.ffd1a8f2.png";